import { find } from "lodash";

import api from "@/api/cloud";
import { set, get } from "@/utils/vuex";
import { createRoom } from '@/store/model/room.js'

const getInitState = () => ({
	items: [],
});

export default {
	namespaced: true,

	state: getInitState,

	getters: {
		items: get("items"),

		rooms: state => state.items,

		roomByName: state => name => find(state.items, { 'name': name }),

		// TODO: Need to verify key used for guid for rooms.
		item: state => id => find(state.items, { id }),

		isInstalled: state => id => {
			//treat all as installed for now;
			return true;
			// const item = find(state.items, { id });
			// return item && item.installed;
		},
	},

	mutations: {
		setRooms: set("items"),

		resetState(state) {
			Object.assign(state, getInitState());
		},
	},

	actions: {
		async load({ commit, dispatch }, community) {
			if (!community) return;

			this._vm.$log(`Rooms: Loading rooms for ${community.name} ${community.identifier}`);

			try {
				if(!api.hasSupportService)
				{
					await dispatch('session/setCommunityId', {  id: community.id, operator: community.operator }, { root: true })
				}

				let rooms = await api.getSystems(community.id);
				rooms = _.map(rooms, room => createRoom(room))
				commit("setRooms", rooms);
			} catch (e) {
				commit("setRooms", []);
				throw e;
			}
		},
	},
};
